import { render, staticRenderFns } from "./page-header-v2.vue?vue&type=template&id=2039cefe&scoped=true"
import script from "./page-header-v2.vue?vue&type=script&lang=js"
export * from "./page-header-v2.vue?vue&type=script&lang=js"
import style0 from "./page-header-v2.vue?vue&type=style&index=0&id=2039cefe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2039cefe",
  null
  
)

export default component.exports